export const RightArrow = ({color}) => {
    let name = `fill-current ${color} self-center`;
    return (
        <svg className={name} width="16" height="16" viewBox="0 0 16 16" align="center">
            <path d="M15.1722 7.51377L7.58242 0.926493C7.52416 0.876269 7.44983 0.848145 7.37149 0.848145H5.59358C5.44492 0.848145 5.37662 1.03297 5.48912 1.12939L12.5244 7.23654H0.768136C0.679743 7.23654 0.607422 7.30886 0.607422 7.39725V8.60261C0.607422 8.691 0.679743 8.76332 0.768136 8.76332H12.5224L5.48711 14.8705C5.37461 14.9689 5.44291 15.1517 5.59157 15.1517H7.42974C7.46791 15.1517 7.50608 15.1377 7.53421 15.1115L15.1722 8.48609C15.2417 8.42562 15.2975 8.35092 15.3357 8.26705C15.3739 8.18318 15.3937 8.09209 15.3937 7.99993C15.3937 7.90777 15.3739 7.81668 15.3357 7.73281C15.2975 7.64894 15.2417 7.57425 15.1722 7.51377Z"/>
        </svg>
    )
}


